import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
	* {
		font-family: 'DM Sans';
	}
`;

export default GlobalStyles;